module.exports = __webpack_public_path__ + "static/media/welcome-cloud-small.7e465e3f.svg";